import { cloneDeep } from 'lodash';
import buttonPrimary from './raw-html';
const parseHtml = htmlString => {
  const parser = new DOMParser();
  return parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
};

const defaultButton = {
  align: 'flex-start',
  backgroundColor: '#606F99',
  color: '#FFFFFF',
  radius: 4,
  iconPrefix: {
    show: false,
    src: '',
  },
  iconSuffix: {
    show: false,
    src: '',
  },
  text: 'Shop Now',
  link: '#',
  show: true,
  subBtn: {
    show: false,
    text: '30-Day Money-Back Guararantee',
  },
  policy: {
    show: true,
    colPerView: 2,
    alignContent: 'center',
    items: [],
  },
};

export const extractButtonBasic = htmlString => {
  const doc = parseHtml(htmlString);
  const container = doc.body.firstElementChild;
  const result = {
    ...cloneDeep(defaultButton),
  };

  const wrapButtonEl = container.querySelector('[data-attribute="wrap-button"]');
  if (wrapButtonEl) {
    result.show = wrapButtonEl.getAttribute('data-show') !== 'false';
    result.align = wrapButtonEl.getAttribute('data-align') || result.align;
  }

  const btnEl = container.querySelector('[data-attribute="btn-link"]');
  if (btnEl) {
    result.link = btnEl.getAttribute('href') || result.link;
    result.backgroundColor = btnEl.getAttribute('data-background') || result.backgroundColor;
    result.color = btnEl.getAttribute('data-color') || result.color;
    result.radius = Number(btnEl.getAttribute('data-radius')) || result.radius;
  }
  const iconPrefixEl = container.querySelector('[data-attribute="icon-prefix"]');
  if (iconPrefixEl) {
    result.iconPrefix.show = iconPrefixEl.getAttribute('data-show') !== 'false';
    result.iconPrefix.src =
      iconPrefixEl.querySelector('[data-attribute="icon-prefix-image"]')?.getAttribute('src') || result.iconPrefix.src;
  }
  const iconSuffixEl = container.querySelector('[data-attribute="icon-suffix"]');
  if (iconSuffixEl) {
    result.iconSuffix.show = iconSuffixEl.getAttribute('data-show') !== 'false';
    result.iconSuffix.src =
      iconSuffixEl.querySelector('[data-attribute="icon-suffix-image"]')?.getAttribute('src') || result.iconSuffix.src;
  }
  const textEl = container.querySelector('[data-attribute="text-btn"]');
  if (textEl) {
    result.text = textEl.textContent.trim() || result.text;
  }
  const subBtnEl = container.querySelector('[data-attribute="sub-btn"]');
  if (subBtnEl) {
    result.subBtn.show = subBtnEl.getAttribute('data-show') !== 'false';
    result.subBtn.text = subBtnEl.textContent.trim() || result.subBtn.text;
  }

  const policyEl = container.querySelector('[data-attribute="sub-grid-btn"]');
  if (policyEl) {
    result.policy.show = policyEl.getAttribute('data-show') !== 'false';
    result.policy.colPerView = Number(policyEl.getAttribute('data-col-perview')) || result.policy.colPerView;
    result.policy.alignContent = policyEl.getAttribute('data-align-content') || 'center';
    const policyItems = policyEl.querySelectorAll('[data-attribute="item-policy"]');
    policyItems.forEach(item => {
      result.policy.items.push({
        icon: item.querySelector('[data-attribute="icon-image"]')?.getAttribute('src') || '',
        text: item.querySelector('[data-attribute="policy-text"]')?.textContent.trim() || '',
      });
    });
  }
  return result;
};

export const updateButtonBasic = (wrapElement, updatedData) => {
  const wrapButtonEl = wrapElement?.querySelector('[data-attribute="wrap-button"]');
  const show = !!updatedData.show;
  if (wrapElement) {
    wrapElement.setAttribute('data-show', show ? 'true' : 'false');
    wrapElement.style.display = show ? 'block' : 'none';
    wrapElement.setAttribute('data-align', updatedData.align || 'center');
    wrapElement.style.setProperty('--align', updatedData.align || 'center');
  }
  if (wrapButtonEl) {
    wrapButtonEl.setAttribute('data-show', show ? 'true' : 'false');
    wrapButtonEl.style.display = show ? 'flex' : 'none';
    wrapButtonEl.setAttribute('data-align', updatedData.align || 'center');
    wrapButtonEl.style.setProperty('--align', updatedData.align || 'center');
  }
  const btnEl = wrapElement.querySelector('[data-attribute="btn-link"]');
  if (btnEl) {
    btnEl.setAttribute('data-show', updatedData.show ? 'true' : 'false');
    btnEl.setAttribute('href', updatedData.link || '#');
    btnEl.setAttribute('data-background', updatedData.backgroundColor || '#606F99');
    btnEl.setAttribute('data-color', updatedData.color || '#FFFFFF');
    btnEl.setAttribute('data-radius', updatedData.radius || '4');
    btnEl.style.backgroundColor = updatedData.backgroundColor || '#606F99';
    btnEl.style.setProperty('--bg-btn', updatedData.backgroundColor || '#606F99');
    btnEl.style.color = updatedData.color || '#FFFFFF';
    btnEl.style.setProperty('--color-btn', updatedData.color || '#FFFFFF');
    btnEl.style.borderRadius = `${updatedData.radius}px`;
    btnEl.style.setProperty('--radius', `${updatedData.radius}px`);
  }
  const iconPrefixEl = wrapElement.querySelector('[data-attribute="icon-prefix"]');
  if (iconPrefixEl) {
    const show = !!updatedData.iconPrefix.show;
    iconPrefixEl.setAttribute('data-show', show ? 'true' : 'false');
    iconPrefixEl.style.display = show ? 'inline-block' : 'none';
    iconPrefixEl.querySelector('[data-attribute="icon-prefix-image"]').setAttribute('src', updatedData.iconPrefix.src);
  }
  const iconSuffixEl = wrapElement.querySelector('[data-attribute="icon-suffix"]');
  if (iconSuffixEl) {
    const show = !!updatedData.iconSuffix.show;
    iconSuffixEl.setAttribute('data-show', show ? 'true' : 'false');
    iconSuffixEl.style.display = show ? 'inline-block' : 'none';
    iconSuffixEl.querySelector('[data-attribute="icon-suffix-image"]').setAttribute('src', updatedData.iconSuffix.src);
  }
  const textEl = wrapElement.querySelector('[data-attribute="text-btn"]');
  if (textEl) {
    textEl.textContent = updatedData.text || 'Shop Now';
  }
  const subBtnEl = wrapElement.querySelector('[data-attribute="sub-btn"]');
  if (subBtnEl) {
    subBtnEl.setAttribute('data-show', updatedData.subBtn.show ? 'true' : 'false');
    subBtnEl.textContent = updatedData.subBtn.text || '';
    subBtnEl.style.display = updatedData.subBtn.show ? 'block' : 'none';
  }
  const policyEl = wrapElement.querySelector('[data-attribute="sub-grid-btn"]');
  if (policyEl) {
    policyEl.setAttribute('data-show', updatedData.policy.show ? 'true' : 'false');
    policyEl.style.display = updatedData.policy.show ? 'flex' : 'none';
    policyEl.setAttribute('data-col-perview', updatedData.policy.colPerView || '2');
    policyEl.setAttribute('data-align-content', updatedData.policy.alignContent || 'center');
    policyEl.style.setProperty('--col-perview', updatedData.policy.colPerView || '2');
    policyEl.style.setProperty('--align-content', updatedData.policy.alignContent || 'center');
    policyEl.innerHTML = updatedData.policy.items
      .map(
        item => `
      <div data-attribute="item-policy" class="wrap-policy-item">
        <div class="icon">
          <img data-attribute="icon-image" src="${item.icon || ''}" alt="">
        </div>
        <div data-attribute="policy-text" class="text">${item.text || ''}</div>
      </div>
    `,
      )
      .join('');
  }
  return wrapElement.outerHTML.trim();
};

export const updateButtonInner = updatedData => {
  const rawHtml = buttonPrimary();

  const doc = parseHtml(rawHtml);
  const wrapButtonEl = doc.body.firstElementChild;
  if (wrapButtonEl) {
    updateButtonBasic(wrapButtonEl, updatedData);
    return wrapButtonEl.innerHTML.trim();
  }

  return '';
};
